












































import { Component, Vue, Model, Emit, Prop } from 'vue-property-decorator';
import { post, get } from '@/unite/api';
import moment from 'moment';
@Component({
  components: {}
})
export default class EditRule extends Vue {
  @Prop() data: any;
  mounted() {
    Object.keys(this.info).forEach(item => {
      this.info[item] = this.data[item];
    });

    this.getPv();
    this.getSv();
    // this.getMode();
  }
  dialogVisible: boolean = true;
  pvList: object[] = [];
  svList: object[] = [];
  modeList: object[] = [];
  pvs: number[] = [];
  svs: number[] = [];
  rules: object = {
    name: [
      {
        required: true,
        message: '请输入订阅名称',
        trigger: 'blur'
      }
    ],
    addr: [
      {
        required: true,
        message: '请输入地址',
        trigger: 'blur'
      }
    ],
    pv: [
      {
        required: true,
        message: '请选择pv',
        trigger: 'blur'
      }
    ],
    sv: [
      {
        required: true,
        message: '请选择sv',
        trigger: 'blur'
      }
    ],
    mode: [
      {
        required: true,
        message: '请选择模式',
        trigger: 'blur'
      }
    ],
    owner: [
      {
        required: true,
        message: '请输入管理者',
        trigger: 'blur'
      }
    ]
  };
  info: any = {
    id: 0,
    unified_number: '',
    unified_name: '',
    unified_type: '',
    unified_code: 1,
    action_code: 1,
    action_rule: '',
    code_rule: ''
  };
  private handleClose() {
    this.$emit('refesh', false);
  }
  private confirm(formName: any) {
    // console.log(this.info);
    (this.$refs[formName] as any).validate((valid: boolean) => {
      if (valid) {
        post('/back/v1/sys/rule/modify', this.info)
          .then(d => {
            this.$message.success('操作成功！');
            this.$emit('refesh', true);
          })
          .catch();
      }
    });
  }
  handleCheckedCitiesChangePv() {
    this.info.unified_code = 0;
    this.pvs.forEach(item => {
      this.info.unified_code += item;
    });
    if (this.pvs[0] === 1) {
      this.info.unified_code = 1;
    }
  }
  handleCheckedCitiesChangeSv() {
    this.info.action_code = 0;
    this.svs.forEach(item => {
      this.info.action_code += item;
    });
    if (this.svs[0] === 1) {
      this.info.action_code = 1;
    }
  }
  private getPv() {
    get('/back/v1/common/pv', {}).then(d => {
      // @ts-ignore
      // console.log(d.Content);
      d.Content.forEach(item => {
        this.pvList = [...this.pvList, { label: item.Desc, value: item.Value }];
        this.pvs = [...this.pvs, item.Value];
      });
      this.pvs = this.pvs.filter(item => this.info.unified_code & item);
    });
  }
  private getSv() {
    get('/back/v1/common/sv', {}).then(d => {
      // @ts-ignore
      d.Content.forEach(item => {
        this.svList = [...this.svList, { label: item.Desc, value: item.Value }];
        this.svs = [...this.svs, item.Value];
      });
      this.svs = this.svs.filter(item => this.info.action_code & item);
    });
  }
}
